const Common = require("./common");
/**
 * APIコール
 */
module.exports = class ApiCall {
  /**
   * カウンター
   * @type {number}
   */
  counter = 0;

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   *
   */
  add() {
    this.counter++;
  }

  /**
   *
   */
  sub() {
    this.counter--;
  }

  /**
   *
   * @returns {boolean}
   */
  busy() {
    this.sub();
    return this.counter > 0;
  }
}
